export interface Company {
  id?: number;
  status: string;
  name?: string;
  street?: string;
  house_number?: string;
  moneybird_contact_id?: string;
  pricing_payment_term?: number;
  created_at?: string;
  country?: string;
  city?: string;
  postal_code?: string;
  vat_number?: string;
  eori_number?: string;
  coc_number?: number;
  article_23?: boolean;
  phone_number?: string;
  invoice_email?: string;
  
  // Picqer integration fields
  picqer_api_key?: string;
  picqer_fulfilment_customer_id?: number;
  picqer_enabled?: boolean;
  picqer_manual_orders_enabled?: boolean;
 
  // WMS provider: 'picqer' | 'channeldock' | null (which WMS is active)
  wms_provider?: 'picqer' | 'channeldock' | null;
  // ChannelDock integration (Seller API per company)
  channeldock_enabled?: boolean;
  channeldock_api_key?: string;
  channeldock_api_secret?: string;
  /** ChannelDock seller id (from Center API / portal). Links this company to a seller in CD. */
  channeldock_seller_id?: number | null;

  // LeanCustoms integration fields
  leancustoms_organization_id?: string;
  leancustoms_contract_id?: string;
}

export interface PicqerFulfilmentCustomer {
  idfulfilment_customer: number;
  name: string;
  active: boolean;
  can_login: boolean;
  username: string;
  language: string;
  idtemplate: number | null;
  preferred_idwarehouse: number | null;
  last_login_at: string | null;
  comment_count: number;
}

/** Company has any WMS connected (Picqer or ChannelDock). */
export function hasWms(company: Pick<Company, 'wms_provider' | 'picqer_enabled' | 'channeldock_enabled'> | null | undefined): boolean {
  if (!company) return false;
  if (company.wms_provider === 'picqer' && company.picqer_enabled) return true;
  if (company.wms_provider === 'channeldock' && company.channeldock_enabled) return true;
  return false;
}

/** Company is using ChannelDock as WMS. */
export function isChannelDock(company: Pick<Company, 'wms_provider' | 'channeldock_enabled'> | null | undefined): boolean {
  return !!(company?.wms_provider === 'channeldock' && company?.channeldock_enabled);
} 